"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const account_1 = require("../../store/redux/account");
const PilotPassengerToggleWeb = () => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'toggle_role' });
    const dispatch = (0, react_redux_1.useDispatch)();
    const asAPilot = (0, react_redux_1.useSelector)(selectors_1.getAsAPilot);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "pilot-passenger-toggle", children: [(0, jsx_runtime_1.jsx)("div", { className: asAPilot ? 'selected' : 'not-selected', onClick: () => dispatch((0, account_1.setAsAPilotAction)(true)), children: (0, jsx_runtime_1.jsx)("span", { children: t("as_pilot") }) }), (0, jsx_runtime_1.jsx)("div", { className: !asAPilot ? 'selected' : 'not-selected', onClick: () => dispatch((0, account_1.setAsAPilotAction)(false)), children: (0, jsx_runtime_1.jsx)("span", { children: t("as_passenger") }) })] }));
};
exports.default = PilotPassengerToggleWeb;
